var map = {
	"./black/index.js": [
		"962e",
		"chunk-8077ef38"
	],
	"./blue/index.js": [
		"7612",
		"chunk-eac132e2"
	],
	"./golden/index.js": [
		"f5d4",
		"chunk-613c6af5"
	],
	"./green/index.js": [
		"23be",
		"chunk-d88251e4"
	],
	"./red/index.js": [
		"9529",
		"chunk-60ad26d2"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ab12";
module.exports = webpackAsyncContext;